import React from 'react';
import { Row, Col } from 'react-bootstrap';

import CustomProtocolOpenerComponent
  from './../Components/CustomProtocolOpenerComponent';

import ArtifactHealthLegend from './ArtifactHealthLegend';
import ArtifactHealthDougnhutContainer
  from './../Containers/ArtifactHealthDoughnutContainer';
import ArtifactHealthPlatformComponent
  from './../Components/ArtifactHealthPlatformComponent';
import ArtifactHealthFilterContainer from './../Containers/ArtifactHealthFilterContainer';
import ArtifactHealthOrderContainer from '../Containers/ArtifactHealthOrderContainer';
import PropTypes from 'prop-types';
import { VerifyArtifactApplicationModalContainer } from '../Containers';

const ArtifactHealthComponent = ({ annotations }) => (
  <Row>
    <Col sm={12} md={8} mdOffset={2}>
      <div className="side-nav">
        <Row>
          <Col md={10} mdOffset={2}>
            <ArtifactHealthLegend />
          </Col>
        </Row>
      </div>
      <Row className="padded" style={{ padding: '50px 0' }}>
        <ArtifactHealthDougnhutContainer platform="Android" />
        <ArtifactHealthDougnhutContainer platform="iOS" />
      </Row>
      <hr />
      <ArtifactHealthFilterContainer />
      <hr />
      <ArtifactHealthOrderContainer />
      <hr />
      <Row>
        <ArtifactHealthPlatformComponent
          platform="Android"
          annotations={annotations}
        />
        <ArtifactHealthPlatformComponent
          platform="iOS"
          annotations={annotations}
        />
      </Row>
      <Row>
        <CustomProtocolOpenerComponent />
      </Row>
    </Col>
    <div>
      <VerifyArtifactApplicationModalContainer />
    </div>
  </Row>
);

ArtifactHealthComponent.propTypes = { annotations: PropTypes.object.isRequired };

export default ArtifactHealthComponent;


// WEBPACK FOOTER //
// src/Components/ArtifactHealthComponent.jsx